<h2 mat-dialog-title style="padding-left:10px;padding-top:10px;padding-right: 10px;">
    <span translate>Lunch Menu</span> - <span>{{transactionDate|date:'MM/dd/yy'}}</span>
</h2>
<mat-dialog-content>
  <table style="width:100%;">
    <tr style="width:100%;" *ngFor="let choice of selectedChoice">
      <td style="width:15%;line-height:30px;white-space: nowrap;">{{choice.Choice}}</td>
      <td style="width:25%;line-height:30px;white-space: nowrap;">{{choice.ChoiceDescription}} </td>
    </tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button image="Cancel.png" label="Close" (click)="closeClick()" translate></tyl-button>
  </div>
</mat-dialog-actions>
